<script>
import errorIcon from '@/assets/images/icons/rating-bad.svg?inline'

export default {
  name: 'FatalError',
  components: {
    errorIcon
  },
  metaInfo: {
    title: 'Кажется что-то пошло не так'
  }
}
</script>
<template>
  <div class="error-card">
    <error-icon
      fill="#ababab"
    />
    <div>
      <h1>500</h1>
      <p>
        Произошла непридвиденная ошибка сервера.
        Вернитесь на
        <router-link :to="{name: 'Main'}">
          главную
        </router-link>
        или перейдите в
        <router-link :to="{name: 'ToursSearch'}">
          поиск туров
        </router-link>
      </p>
    </div>
  </div>
</template>